import DailyMenuOptionOfferOrder from "@/model/dailymenu/DailyMenuOptionOfferOrder";

export default class DailyMenuOptionOrder {
  private constructor (
    readonly id: string,
    readonly name: string,
    readonly code: string,
    readonly isSelected: boolean,
    readonly offer: DailyMenuOptionOfferOrder | undefined

  ) {}


  static createFromResponse (responseData: any[]): DailyMenuOptionOrder[] {

    return responseData.map( (value:any):DailyMenuOptionOrder =>new DailyMenuOptionOrder(
        value.id,
        value.name,
        value.code,
        value.selected,
        DailyMenuOptionOfferOrder.createFromResponse(value.offer)

    ))

  }
}
